import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetIntensityDegreesInputDto, IntensityDegreeCreateDto, IntensityDegreeDto, IntensityDegreeExcelDownloadDto, IntensityDegreeUpdateDto } from '../dtos/intensity-degree/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class IntensityDegreeService {
  private restService = inject(RestService);
  apiName = 'Planning';
  

  create = (input: IntensityDegreeCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IntensityDegreeDto>({
      method: 'POST',
      url: '/api/planning/intensityDegrees',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/planning/intensityDegrees/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/planning/intensityDegrees',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IntensityDegreeDto>({
      method: 'GET',
      url: `/api/planning/intensityDegrees/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/planning/intensityDegrees/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetIntensityDegreesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<IntensityDegreeDto>>({
      method: 'GET',
      url: '/api/planning/intensityDegrees',
      params: { incidentTypeId: input.incidentTypeId, incidentTypeName: input.incidentTypeName, intensityId: input.intensityId, intensityName: input.intensityName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: IntensityDegreeExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/planning/intensityDegrees/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, incidentTypeId: input.incidentTypeId, incidentTypeName: input.incidentTypeName, intensityId: input.intensityId, intensityName: input.intensityName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IntensityDegreeDto[]>({
      method: 'GET',
      url: '/api/planning/intensityDegrees/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: IntensityDegreeUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IntensityDegreeDto>({
      method: 'PUT',
      url: `/api/planning/intensityDegrees/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}